import {useEffect,useState} from 'react';
import {API} from '@/App';
import {journey} from '../search/useDiscoverySearch';

export const useHeaderAccount = user => {
  const [account,setAccount]=useState(user);
  const [subscription,setSubscription]=useState({});
  const [alerts,setAlerts]=useState(0);
  const token=localStorage.getItem('session_token');
  useEffect(()=>{if(user)setAccount(user);},[user]);
  useEffect(()=>{
    const back=()=>{const last=Number(sessionStorage.getItem('bds_last_report_open'));if(last&&Date.now()-last<30000){journey('backtracked');sessionStorage.removeItem('bds_last_report_open');}};
    window.addEventListener('popstate',back);return()=>window.removeEventListener('popstate',back);
  },[]);
  useEffect(()=>{
    const controller=new AbortController();
    const get=async(path,set)=>{
      try{const res=await fetch(`${API}${path}`,{headers:{Authorization:`Bearer ${token}`},signal:controller.signal});if(res.ok)set(await res.json());}catch{ /* Optional account indicators must not block search. */ }
    };
    if(token){if(!user?.role)get('/auth/me',setAccount);get('/subscriptions/status',setSubscription);get('/catalysts/watches',d=>setAlerts(d.alerts_count || 0));}
    return ()=>controller.abort();
  },[token,user?.role]);
  return {account,subscription,alerts,setAlerts};
};